import React, { useEffect } from 'react';
import Brand from '../../brand';
import { useHistory, useLocation } from 'react-router-dom';
import Icon from '../../commons/icon';
import './index.scss';
import { useGoPrehome } from '../../../hooks/useGoPrehome';
import {
  gaSectionAccess,
  gaSubSectionAccess,
} from '../../../services/analitics';
import { useSelector } from 'react-redux';

export default function PageFrameFloor({ children }) {
  const history = useHistory();
  const { floorKey, sectionKey } = useSelector((state) => state.location);
  const { storeId, userLocale } = useSelector((state) => state.config);
  const { pathname } = useLocation();
  const { navigateToPreHome } = useGoPrehome();

  useEffect(() => {
    window.scrollTo(0, 0);
    sessionStorage.setItem('welcome', true);
  }, [pathname]);

  const goBack = () => {
    if (sessionStorage.getItem('gaSection') === 'root') {
      gaSectionAccess(storeId, userLocale, floorKey, sectionKey);
    } else {
      gaSubSectionAccess(
        storeId,
        userLocale,
        floorKey,
        sectionKey,
        window.location.href.slice(0, -8)
      );
    }
    history.goBack();
  };

  const backButton = () => {
    return (
      <span onClick={goBack} className={'pageframe_back-icon'}>
        <Icon icon={'back'} />
      </span>
    );
  };

  return (
    <>
      <div className={'pageframe-floor_header'}>
        <header className={'page-header fixed-header'}>
          {backButton()}
          <Brand onclickBrand={navigateToPreHome} />
        </header>
      </div>
      <div className={'page-body-floor'}>{children}</div>
    </>
  );
}
